import {
    createSlice,
} from '@reduxjs/toolkit';

import {
    addSelection,
    removeSelection,
    clearSelections,
} from '~Betslip/actions/userSelectionsActions';

import {
    clearFreebets,
} from '~Betslip/actions/freeBetsActions';

import {
    updateUserParlay,
} from '~Betslip/actions/parlayTabActions';

const initialState = {
    userParlay: {
        stake: 0,
        each_way_selected: false,
        free_bet_id: null,
    },
    userSingles: {
        stake: 0,
        each_way_selected: false,
    },
};

const parlayTab = createSlice({
    name: 'betslip/parlayTab',
    initialState,
    reducers: {
        updateUserSingles: (state, action) => {
            Object.assign(state.userSingles, action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(
            updateUserParlay,
            (state, action) => {
                Object.assign(state.userParlay, action.payload);
            },
        )
        .addCase(addSelection, () => (initialState))
        .addCase(removeSelection, () => (initialState))
        .addCase(clearSelections, () => (initialState))
        .addCase(
            clearFreebets,
            ({ userParlay }) => {
                Object.assign(userParlay, { free_bet_id: null });
            },
        );
    },
});

export const {
    updateUserSingles,
} = parlayTab.actions;

export default parlayTab.reducer;
